import type { TreeDataNode } from 'antd';
import type { Key } from 'react';

export function isSubset<T>(a: Set<T>, b: Set<T>): boolean {
  for (const x of a) if (!b.has(x)) return false;
  return true;
}

export function computeCheckedKeysForTree(
  selectedLeafKeys: Set<Key>,
  descendantLeafMap: Map<Key, Set<Key>>
): Key[] {
  const checked: Key[] = [];
  // родитель отмечается, если ВСЕ его листья выбраны
  for (const [nodeKey, leaves] of descendantLeafMap.entries()) {
    if (isSubset(leaves, selectedLeafKeys)) {
      checked.push(nodeKey);
    }
  }
  for (const k of selectedLeafKeys) if (!checked.includes(k)) checked.push(k);
  return checked;
}

export function extractLeafKeysFromChecked(
  nextCheckedKeys: Key[],
  descendantLeafMap: Map<Key, Set<Key>>,
  leafSet: Set<Key>
): Key[] {
  const result = new Set<Key>();
  for (const k of nextCheckedKeys) {
    if (leafSet.has(k)) {
      result.add(k);
    } else {
      const leaves = descendantLeafMap.get(k);
      if (leaves) for (const l of leaves) if (leafSet.has(l)) result.add(l);
    }
  }
  return Array.from(result);
}

export function collectLeafKeys(treeData: TreeDataNode[]): Set<Key> {
  const out = new Set<Key>();
  const walk = (nodes: TreeDataNode[]) => {
    for (const n of nodes) {
      const children = n.children as TreeDataNode[] | undefined;
      if (!children || children.length === 0 || n.isLeaf) out.add(n.key);
      if (children && children.length) walk(children);
    }
  };
  walk(treeData);
  return out;
}

export function buildDescendantLeafMap(
  treeData: TreeDataNode[]
): Map<Key, Set<Key>> {
  const map = new Map<Key, Set<Key>>();

  const visit = (node: TreeDataNode): Set<Key> => {
    const children = node.children as TreeDataNode[] | undefined;
    if (!children || children.length === 0) {
      const leafSet = new Set<Key>([node.key]);
      map.set(node.key, leafSet);
      return leafSet;
    }
    const agg = new Set<Key>();
    for (const ch of children) {
      for (const k of visit(ch)) agg.add(k);
    }
    map.set(node.key, agg);
    return agg;
  };

  for (const n of treeData) visit(n);
  return map;
}
